import { z } from 'zod'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AcceptInvitation } from '@/features/organizations/accept-invitation'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

const paramsSchema = z.object({
  invitationId: z.string(),
})

export const Route = createFileRoute('/accept-invitation/$invitationId')({
  component: AcceptInvitation,
  validateSearch: searchSchema,
  params: paramsSchema,
})

